import Height from 'height-js'

function setHeightPostCardForGreatPetPicks() {
  const isDesktopVersion = window.innerWidth >= 768

  const listShowPostsGrid = Array.from(
    document.querySelectorAll(
      '.PageMain--great-pet-picks .MoreFeaturedCategories'
    )
  )

  listShowPostsGrid.forEach(function (item) {
    const listContainer = Array.from(
      item.querySelectorAll('.PostsGridContainer')
    )
    const columns = listContainer.length

    if (!columns) {
      return
    }

    let columnReference = { columnIndex: 0, numberCards: 0 }

    listContainer.forEach(function (item, index) {
      const postsGrid = listContainer[index].querySelectorAll('.PostCard')
      if (postsGrid.length > columnReference.numberCards) {
        columnReference = { columnIndex: index, numberCards: postsGrid.length }
      }
    })

    const firstContainerCards = Array.from(
      listContainer[columnReference.columnIndex].querySelectorAll('.PostCard')
    )

    // reset height
    const listPostCard = Array.from(
      item.querySelectorAll('.PostsGridContainer .PostCard')
    )
    listPostCard.forEach((item) => (item.style.height = ''))

    if (!isDesktopVersion) {
      return
    }

    firstContainerCards.forEach(function (card) {
      const listElem = `.${Array.from(item.classList).join(
        '.'
      )} .PostsGridContainer .${Array.from(card.classList).join('.')}`

      Height({ columns, listElem })
    })
  })
}

export default function () {
  setHeightPostCardForGreatPetPicks()
  window.addEventListener('resize', setHeightPostCardForGreatPetPicks)
}
